import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import { dataHooks } from './constants';
import Button from '../button/button';
import ArrowLeftSymbol from '../icons/arrowLeftSmall.svg.js';

var BackButton = function BackButton(_ref) {
  var automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      onClick = _ref.onClick,
      label = _ref.label,
      translateIfNeeded = _ref.translateIfNeeded;
  return /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHook,
    automationId: automationId,
    className: "btn-back",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ArrowLeftSymbol, null), /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHooks.label
  }, translateIfNeeded(label)));
};

BackButton.displayName = 'BackButton';
BackButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
export default compose(BackButton);